<template>
  <div class="row pt-3 pb-3">
    <div
      class="col-12 text-red-500 px-3"
      v-for="(debito, i) in debitos"
      :key="`debito${i}`"
    >
      <span> {{ debito.descricao }} - </span>
      <span class="float-right">
        {{ debito.valor }}
      </span>
    </div>

    <div
      class="col-12 text-green-500 px-3"
      v-for="(detalhe, i) in investimento.detalheInvestimentos"
      :key="`detalhe${i}`"
    >
      <span> {{ detalhe.pagadora }} - </span>
      <span class="float-right">
        {{ formatarValor(detalhe.valor) }}
      </span>
    </div>

    <div class="col-12 px-3">
      <span> Total restante - </span>
      <span class="float-right">
        {{
          formatarValor(
            (investimento ? investimento.totalPrevisto : 0) -
              (investimento
                ? /*removerValor(investimento.valorAlocado)*/ investimento.totalAlocado
                : 0)
          )
        }}
      </span>
    </div>

    <div class="col-12"><hr /></div>

    <div class="col-12 col-md-4 text-center">
      <b-badge>Total previsto</b-badge>
      <div>{{ formatarValor(investimento ? investimento.totalPrevisto : 0) }}</div>
    </div>
    <div class="col-12 col-md-4 text-center">
      <b-badge>Total alocado</b-badge>
      <div>{{ formatarValor(investimento ? investimento.totalAlocado : 0) }}</div>
    </div>
    <div class="col-12 col-md-4 text-center">
      <b-badge>Total restante</b-badge>
      <div>
        {{
          formatarValor(
            (investimento ? investimento.totalPrevisto : 0) -
              (investimento
                ? /*removerValor(investimento.valorAlocado)*/ investimento.totalAlocado
                : 0)
          )
        }}
      </div>
    </div>
  </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import PropostaService from "@/common/services/proposta/proposta.service";

export default {
  props: {
    investimento: {
      required: true,
      default: () => ({
        recebedora: "",
        totalPrevisto: 0,
        totalAlocado: 0,
        valorAlocado: 0,
      }),
    },
    rubrica: {
      required: true,
    },
    endpoint: {},
  },
  data: () => ({
    debitos: [],
  }),
  methods: {
    formatarValor: helpers.formatarValor,
    removerValor: helpers.removerValor,
  },
  watch: {
    investimento: {
      handler() {
        let id = null;
        if (this.investimento.propostaId) {
          id = this.investimento.propostaId;
          PropostaService.setEndpoint("Proposta");
        } else if (this.investimento.propostaEmpresaProponenteId) {
          id = this.investimento.propostaEmpresaProponenteId;
          PropostaService.setEndpoint("PropostaEmpresaProponente");
        } else if (this.investimento.propostaEmpresaExecutoraId) {
          id = this.investimento.propostaEmpresaExecutoraId;
          PropostaService.setEndpoint("PropostaEmpresaExecutora");
        } else if (this.investimento.propostaEmpresaCooperadaId) {
          id = this.investimento.propostaEmpresaCooperadaId;
          PropostaService.setEndpoint("PropostaEmpresaCooperada");
        }

        let tipo = "tipo";
        let endpoint = this.rubrica;
        switch (this.rubrica) {
          case "servico-terceiro":
            tipo = "tipoServico";
            break;
          case "material-consumo":
            tipo = "tipoMaterial";
            break;
          case "material-permanente-equipamento":
            tipo = "tipoMaterial";
            endpoint = "material-permanente";
            break;
          case "viagem-diaria":
            tipo = "tipoViagem";
            break;
          case "outro-recurso":
            tipo = "tipoRecurso";
            break;
        }

        PropostaService.buscarDespesa(id, endpoint).then((res) => {
          if (this.rubrica == "recurso-humano") {
            this.debitos = res.data.data.equipe.alocacaoHorasIndividuais.map((el) => {
              let totalHoras = el.horasSazonais.reduce((total, hora) => {
                return (total += hora.horas);
              }, 0);
              let valorTotal = el.valorHora * totalHoras;
              return {
                descricao: `${el.pessoa.nome} (${
                  el.funcao
                    ? helpers.getEnum(el.funcao)
                      ? helpers.getEnum(el.funcao).text
                      : "Sem função"
                    : "-"
                })`,
                valor: helpers.formatarValor(valorTotal),
              };
            });
          } else {
            this.debitos = res.data.data.map((el) => {
              return {
                descricao: helpers.getEnum(el[tipo]).text,
                valor: helpers.formatarValor(el.valor),
              };
            });
          }
        });
        PropostaService.setEndpoint(this.endpoint);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang=""></style>
